// dateFormats.js
export const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY'
export const DATE_DISPLAY_FORMAT_TIME_AND_DATE = 'HH:mm, DD/MM/YYYY'
